import styled from 'styled-components';

import { Text } from '~/components/ui/Text';

const StyledInput = styled.input`
	width: 100%;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	padding: 15px 60px 15px 15px;

	color: #ffffff;
	font-family: GT Walsheim Pro;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;

	transition: all 0.3s ease;

	&:focus {
		outline: none;
	}
`;

const StyledIcon = styled.img`
	transition: filter 0.3s ease;
	pointer-events: none;
	user-select: none;
`;

const StyledTextLabel = styled(Text)`
	color: #ffffff;
	font-weight: 400;
	transition: filter 0.3s ease;

	span:first-child {
		font-size: 16px;
	}

	span:last-child {
		font-size: 14px;
		opacity: 0.5;
	}
`;

const StyledRightContainer = styled.div`
	position: absolute;
	top: 50%;
	right: 20px;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	column-gap: 10px;
`;

const StyledContainer = styled.div`
	position: relative;

	&:hover,
	&:active,
	&:focus {
		${StyledInput} {
			background-color: rgba(255, 255, 255, 1);
			color: #000000;

			&
				+ ${StyledRightContainer}
				${StyledIcon},
				&
				+ ${StyledRightContainer}
				${StyledTextLabel} {
				filter: invert(100%);
			}
		}
	}
`;

export {
	StyledContainer,
	StyledIcon,
	StyledInput,
	StyledRightContainer,
	StyledTextLabel,
};
